<template>
<div class="col-12 col-lg-4 mb-4">
  <div class="card h-100 mb-3 card-light text-lg-start">
    <div class="image-library" :aria-label="item.title" >
      <a :href="item.link" target="_blank" download class="image-wrap w-100 justify-content-center p-3 bg-light">
        <img :src="item.image.url" :alt="item.image.alt" />
      </a>
    </div>
    <div class="card-body d-flex flex-column py-3">
      <h3 class="card-title mb-3 text-capitalize">
        <a :href="item.link" class="text-black d-flex justify-content-between" target="_blank" download>
          {{ item.title }} <BIconDownload />
        </a>
      </h3>
    </div>
  </div>
</div>
</template>
<script>
  export default {
    props: ['item']
  }
</script>
